import React from 'react';
import { SectionWrapper } from './shared/SectionWrapper';
export function TruthSection() {
  return <SectionWrapper bg="cream" data-id="element-286">
      <div className="max-w-3xl mx-auto" data-id="element-287">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-warm-dark mb-8" data-id="element-288">
          La verdad que cambia todo
        </h2>

        <p className="text-lg text-warm-muted mb-8 text-center" data-id="element-289">
          La mayoría de los problemas típicos (levantamientos, terminación
          irregular, tiempos eternos) no son "porque el producto es malo" o
          "porque te falta mano".
        </p>

        <p className="font-medium text-warm-dark mb-6 text-center" data-id="element-290">
          Casi siempre vienen de:
        </p>

        <div className="bg-white rounded-2xl p-8 shadow-soft border border-blush mb-10" data-id="element-291">
          <ul className="space-y-6" data-id="element-292">
            <li className="flex items-center gap-4" data-id="element-293">
              <div className="w-3 h-3 rounded-full bg-rose shrink-0" data-id="element-294"></div>
              <span className="text-lg text-warm-dark" data-id="element-295">
                <strong className="text-rose" data-id="element-296">Preparación incompleta</strong> (o
                agresiva)
              </span>
            </li>
            <li className="flex items-center gap-4" data-id="element-297">
              <div className="w-3 h-3 rounded-full bg-rose shrink-0" data-id="element-298"></div>
              <span className="text-lg text-warm-dark" data-id="element-299">
                <strong className="text-rose" data-id="element-300">Estructura sin criterio</strong>{' '}
                (perfil / apex)
              </span>
            </li>
            <li className="flex items-center gap-4" data-id="element-301">
              <div className="w-3 h-3 rounded-full bg-rose shrink-0" data-id="element-302"></div>
              <span className="text-lg text-warm-dark" data-id="element-303">
                <strong className="text-rose" data-id="element-304">Torno y fresas mal usadas</strong>{' '}
                (o sin un orden claro)
              </span>
            </li>
            <li className="flex items-center gap-4" data-id="element-305">
              <div className="w-3 h-3 rounded-full bg-rose shrink-0" data-id="element-306"></div>
              <span className="text-lg text-warm-dark" data-id="element-307">
                <strong className="text-rose" data-id="element-308">Sellado y acabado</strong> sin
                estándar
              </span>
            </li>
          </ul>
        </div>

        <div className="text-center" data-id="element-309">
          <p className="text-xl text-warm-dark font-medium" data-id="element-310">
            O sea: no te falta talento.
          </p>
          <p className="text-3xl font-serif font-bold text-rose mt-2" data-id="element-311">
            Te falta método profesional.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}